import { Card, Image, Flex, Text, Button } from '@chakra-ui/react';
import { NavLink, useParams } from 'react-router-dom';

export default function LimitedHome() {
  const { workspaceId } = useParams<{ workspaceId: string }>();

  return (
    <Card.Root minH={'100vh'} mx={'auto'} width={{ md: '90%' }} maxW={'6xl'} pb={6}>
      <Card.Body maxWidth={'2xl'} mx={'auto'}>
        <Flex justify={'center'} align={'center'} direction={'column'}>
          <Image src='/logo.png' alt='Coach Hub' height={16} mb={3} />
          <Text fontSize={'2xl'} fontWeight={'medium'} mb={3}>
            Your subscription has been cancelled
          </Text>
          <Text fontSize={'sm'} textAlign={'center'} mb={8}>
            You can no longer access this team or any of your coaching content. If you enjoyed your
            expereince please choose a paid plan that's right for your and get back to coaching your
            team!
          </Text>
          <Button colorPalette='brand' asChild>
            <NavLink to={`/limited/${workspaceId}/resume-subscription`}>
              Resume Subscription
            </NavLink>
          </Button>
        </Flex>
      </Card.Body>
    </Card.Root>
  );
}
